import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { HttpService } from '../service/http.service';
import { PdfDocumentTemplateCss } from '../pdf-document-template-css';
import { ToastMessageService } from '../toast-message.service';

@Component({
  selector: 'app-edit-pdf-template-css',
  templateUrl: './edit-pdf-template-css.component.html',
  styleUrls: ['./edit-pdf-template-css.component.css']
})
export class EditPdfTemplateCssComponent implements OnInit {

  templateCss!: PdfDocumentTemplateCss;
  cssForm!: FormGroup;

  constructor(
    private httpService: HttpService,
    private toastService: ToastMessageService,
    private builder: FormBuilder,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    let templateId = Number(this.route.snapshot.paramMap.get("cssId"));
    this.httpService.getPdfDocumentTemplateCssById(templateId).subscribe(css => {
      this.templateCss = css;
      this.cssForm = this.builder.group({
        body: this.templateCss.body
      });
    });
  }

  updateCss(){
    this.templateCss.body = this.cssForm.value.body;
    this.httpService.putPdfDocumentTemplateCss(this.templateCss).subscribe(() => {
      this.toastService.addSuccess("Success", "CSS updated");
    }, error => this.toastService.addError("Error 😥", error.message));
  }

}
